import {useNavigate,useParams} from 'react-router-dom';

import useUser from '../../hooks/useUser';
import {useGetCasesQuery} from '../../redux/services/caseApi';
import AppDashboard from '../AppDashboard';
import ViewCaseScreen from '../../components/cases/ViewCaseScreen';

const ViewCasePage = props => {
  const {id} = useParams();
  const navigate = useNavigate();
  const casesQuery = useGetCasesQuery({id}, {skip: !id});
  // const user = useUser();
  const childProps = {
    caseData: casesQuery?.data?.data?.[0],
    loading: casesQuery.isLoading,
  };
  return (
    <AppDashboard
      title='Case Details'
      loading={casesQuery.isLoading && !childProps.caseData}
      hasNoData={!childProps.loading && !childProps.caseData}
      onBack={() => navigate('/providers/cases')}
    >
      <ViewCaseScreen {...childProps} />
    </AppDashboard>
  );
};

export default ViewCasePage;
